<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" class="layout-padd"
[ngStyle]="{'max-height.px': innerHeight}">

  <div fxLayout="row" fxLayoutAlign="center center" class="layout-padd full-w divider">
    <i class="material-icons primary-ico" style="font-size: 3em;">shopping_cart</i>
  </div>

  <div fxLayout="row" class="layout-padd" class="text-center">
    <span class="mat-subheading-1">{{'PreventlossallComponent.orderyet'|translate}}     
    </span>
  </div>

  <div fxLayout="column" fxLayoutGap="10px" class="full-w">

    <button mat-button color="accent" (click)="close(true)" angulartics2On="click"
      angularticsAction="recoverCurrentOrder" angularticsCategory="preventLossUser">
      {{'PreventlossallComponent.getorder'|translate}} 
     
    </button>

    <button mat-button color="primary" (click)="close(false)" angulartics2On="click" angularticsAction="beginNewOrder"
      angularticsCategory="preventLossUser">
      {{'PreventlossallComponent.neworder'|translate}} 
    
    </button>

  </div>


</div>